import StorageUtil from "@/utils/StorageUtil";

export default {

    isLogin() {
        return this.getUserToken() !== undefined && this.getUserToken() !== null;
    },

    clear() {
        StorageUtil.remove("userData");
        StorageUtil.remove("userToken");
    },

    getUserData(key) {
        try {
            const userData = StorageUtil.getObject("userData");
            if (userData && key && key.trim().length > 0) {
                return userData[key];
            } else {
                return userData;
            }
        } catch (e) {
            return null;
        }
    },

    setUserData(data) {
        StorageUtil.setObject("userData", data);
    },

    getUserToken() {
        return StorageUtil.getObject("userToken");
    },

    setUserToken(data) {
        StorageUtil.setObject("userToken", data);
    },

    getUserPhone() {
        const phone = this.getUserData("phone_number");
        return phone ? phone.substr(0, 3) + "****" + phone.substr(7, 4) : "--";
    },
}
